const mutations = {
    scheduleListMutation(state, value) {
        state.scheduleList = { ...state.scheduleList, ...value };
    },

    tempDateMutation(state, value) {
        state.tempDate = value;
    }
};

export default mutations;